import { defineMessages } from "react-intl"

export const messages = defineMessages({
	headerExteriorColor: {
		defaultMessage: "Exterior Color",
		id: "inventorylist.header.exteriorColor",
	},
	headerFirstRegistrationDate: {
		defaultMessage: "First Registration",
		id: "inventorylist.header.firstRegistrationDate",
	},
	headerInteriorColor: {
		defaultMessage: "Interior Color",
		id: "inventorylist.header.interiorColor",
	},
	headerInventoryDuration: {
		defaultMessage: "Time",
		id: "inventorylist.header.inventoryDuration",
	},
	headerInventoryStatus: {
		defaultMessage: "Stock Status",
		id: "inventorylist.header.inventoryStatus",
	},
	headerLocation: {
		defaultMessage: "Location",
		id: "inventorylist.header.location",
	},
	headerMileage: {
		defaultMessage: "Mileage",
		id: "inventorylist.header.mileage",
	},
	headerModelName: {
		defaultMessage: "Model",
		id: "inventorylist.header.modelName",
	},
	headerModelYear: {
		defaultMessage: "Model Year",
		id: "vehicle.modelInformation.modelYear",
	},
	headerNumber: {
		defaultMessage: "Inventory No.",
		id: "inventorylist.header.number",
	},
	headerPrice: {
		defaultMessage: "Price",
		id: "inventorylist.header.price",
	},
	headerPriceChanged: {
		defaultMessage: "Since",
		id: "inventorylist.header.priceChanged",
	},
	headerSalesStatus: {
		defaultMessage: "Sales Status",
		id: "inventorylist.header.salesStatus",
	},
	headerVehicleType: {
		defaultMessage: "Type",
		id: "inventorylist.header.vehicleType.short",
	},
	noResultsHeadline: {
		defaultMessage: "Adjust your query or search in other inventories.",
		id: "inventorylist.noResults.subline",
	},
	noResultsSubline: {
		defaultMessage: "0 Vehicles found in Inventory.",
		id: "inventorylist.noResults.headline",
	},
})
